interface Page {
  title: string;
  number: number;
}

export const state = () => ({
  currentPage: '',
  totalPages: 5
});

export const mutations = {
  setCurrentPage(state: any, currentPage: string) {
    state.currentPage = currentPage;
  }
};

export const actions = {
  setCurrentPage(context: any, payload: Page) {
    context.commit('setCurrentPage', payload);
  }
};
